import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { Select } from 'primeng/select';

interface MultiSelectFieldProps extends FormlyFieldProps {
  optionValue: string;
  optionLabel: string;
  canFilter: boolean;
  canClear: boolean;
  placeholderText: string;
  selectOptions: {
    label: string;
    value: number | string | boolean;
  }[];
}

@Component({
  selector: 'app-multi-select-field',
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    MultiSelectModule,
    TranslatePipe,
    NgIf,
  ],
  templateUrl: './multi-select-field.component.html',
  styleUrl: './multi-select-field.component.scss',
})
export class MultiSelectFieldComponent extends FieldType<
  FieldTypeConfig<MultiSelectFieldProps>
> {
  override defaultOptions = {
    props: {
      optionLabel: 'label',
      optionValue: 'value',
      placeholderText: 'COMMON.CHOOSE',
      canFilter: false,
      canClear: false,
      selectOptions: [],
    },
  };
}
